module.exports = __webpack_public_path__ + "img/lunbo43.3995d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/lunbo43.png
// module id = IDYk
// module chunks = 0